import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Quotes } from "@phosphor-icons/react";
import PageHeader from "@/components/PageHeader";
import { TESTIMONIALS } from "@/lib/siteData";

export default function Testimonials() {
  return (
    <div data-testid="testimonials-page">
      <PageHeader
        eyebrow="— Testimonials"
        title="Word from farmers, builders and folks who've worked with us."
        intro="The real measure of an earthworks contractor is what people say a couple of winters down the track. Here's some of what we hear."
      />

      <section className="section-pad bg-[#F6F5F2]">
        <div className="container-fz grid grid-cols-1 md:grid-cols-2 gap-px bg-[#D2D0C9] border border-[#D2D0C9]">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`testimonial-card-${i}`}
              className="bg-[#F6F5F2] hover:bg-white p-10 md:p-14 transition-colors flex flex-col"
            >
              <Quotes
                size={36}
                weight="fill"
                className="text-[#D05322]"
              />
              <blockquote className="mt-6 font-display text-2xl md:text-3xl text-stone-900 leading-snug flex-1">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-10 pt-6 border-t border-[#D2D0C9]">
                <p className="font-bold text-stone-900">{t.name}</p>
                <p className="text-sm text-stone-500 mt-1 uppercase tracking-[0.18em]">
                  {t.role}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <div className="container-fz mt-16 text-center">
          <p className="eyebrow mb-4">Want to be next?</p>
          <h3 className="font-display text-3xl md:text-4xl text-stone-900 max-w-2xl mx-auto">
            Let's talk about your project.
          </h3>
          <div className="mt-8 inline-block">
            <Link to="/contact" data-testid="testimonials-contact-link" className="btn-primary">
              Request a quote <ArrowRight size={16} weight="bold" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
